import { useState } from 'react'
import { SPLASH_SESSION_KEY } from '../utils/constants'

const useSplashScreen = () => {
    const [showSplash, setShowSplash] = useState(() => {
        const splashValue = sessionStorage.getItem(SPLASH_SESSION_KEY)
        return splashValue === null || splashValue !== 'false'
    })
    return [showSplash, setShowSplash]
}

export { useSplashScreen }
